import React from "react";
import "../styles/aboutus.css";

export default class AboutUsDetails extends React.Component {
    render() {
        return (
           <div className="details">
                <span className="detailsHeading">
                    ABOUT US
                </span>
               <p>
                   <h1>-</h1>
               </p>
               <p className="padding-around detailsContent">
                   We, at CA Siddharth S. Dwivedi & Co., provide a wide range of services such as Income Tax, NRI Taxation,
                   Goods & Service Tax (GST), Corporate Advisory and Compliance, Book Keeping and Accounting, Business setup services,
                   and many more.
               </p>
               <p className="padding-around detailsContent">We are your “one stop solution” for all the financial and tax related problems.</p>
           </div>
        )
    }
}